// extracted by mini-css-extract-plugin
module.exports = {"Prose":"Prose_Prose__2kjAf","inverse":"Prose_inverse__1nkR3"};